import { useMemo } from 'react';
import { useStaticAppStore } from './useStaticAppStore';

export function useIsMe(userId: string | undefined) {
  const { user } = useStaticAppStore();

  return useMemo(() => userId === user?.user_id, [userId, user?.user_id]);
}
